export const routeMap = {
  LOGIN: '/login',
  DASHBOARD: {
    ROOT: '/',
    INDEX: '/',
    ALERTS: '/alerts',
    MESSAGES: '/messages',
    TASKS: '/tasks',
    PROFILE: '/profile'
  }
}

export const appLabels: Record<string, string> = {
  "lucent-health": "Lucent Health",
  "communicare": "My Health 365"
}
